import {
  InstructionIntroItem,
  InstructionSection,
  PaletteLegendItem,
} from './model/test-series.model';

export const GENERAL_INSTRUCTION_ITEMS: InstructionIntroItem[] = [
  {
    id: 'general-1',
    text: 'Total duration of National NEET-PG Mock 2024 (New NEET-PG Pattern) is 210 minutes.',
  },
  {
    id: 'general-2',
    text: 'The Question Palette displayed on the right side of screen will show the status of each question using one of the following symbols:',
  },
  {
    id: 'general-3',
    text: 'The Marked for Review status for a question simply indicates that you would like to look at that question again.',
    highlightedText:
      'If an answer is selected for a question that is Marked for Review, the answer will be considered in the final evaluation.',
  },
];

export const QUESTION_PALETTE_LEGEND: PaletteLegendItem[] = [
  { id: 'not-visited', label: 'You have not visited the question yet.', tone: 'slate', count: '1' },
  { id: 'not-answered', label: 'You have not answered the question.', tone: 'red', count: '2' },
  { id: 'answered', label: 'You have answered the question.', tone: 'green', count: '3' },
  {
    id: 'marked',
    label: 'You have NOT answered the question, but have marked the question for review.',
    tone: 'purple',
    count: '4',
  },
  {
    id: 'marked-answered',
    label: 'The question(s) "Answered and Marked for Review" will be considered for evaluation.',
    tone: 'violet',
    count: '5',
  },
];

export const EXAM_INSTRUCTION_SECTIONS: InstructionSection[] = [
  {
    id: 'parts',
    title: 'Groups:',
    items: [
      'This test is divided into 5 groups - Group A, B, C, D & E.',
      'Each group will have 40 questions and is allotted 42 minutes.',
      'You cannot proceed to the next group until you complete the 42 minutes of the previous group.',
      'The next group will start automatically after the completion of the previous group.',
      'You cannot review/modify your responses for a group after you complete the allotted time.',
      'The test will be auto submitted after 210 minutes.',
      'You cannot use multiple devices to take this test.',
      'Do not switch to another tab, window, or app, and do not exit full-screen mode during the test. Each time you do, you will receive a warning. After 3 warnings, your test will be automatically submitted.',
    ],
  },
  {
    id: 'navigation',
    title: 'Navigating to a Question:',
    items: [
      'To answer a question, do the following: Click on the question number in the Question Palette at the right of your screen to go to that numbered question directly. Click on Save & Next to save your answer for the current question and then go to the next question. Click on Mark for Review & Next to mark your question for review, and then go to the next question.',
      'You can view all the questions by clicking on the Question Paper button. Note that the options for multiple choice type questions will not be shown.',
    ],
  },
  {
    id: 'answering',
    title: 'Answering a Question:',
    items: [
      'Procedure for answering a multiple choice type question: To select your answer, click on the button of one of the options. To deselect your choosen answer, click on the button of the choosen option again or click on the Clear Response button. To change your choosen answer, click on the button of another option. To save your answer, you MUST click on the Save & Next button. To mark the question for review, click on the Mark for Review & Next button. If an answer is selected for a question that is Marked for Review, the answer will be considered in the final evaluation.',
      'To change your answer to a question that has already been answered, first select that question for answering and then follow the procedure for answering a question as indicated above.',
      'Note that ONLY Questions for which answers are saved after answering will be considered for evaluation. This will also include questions that have been answered and marked for review.',
    ],
  },
  {
    id: 'mock-test',
    title: 'Instructions for Mock Test',
    items: [
      'This is a Mock test. The Questions displayed are for practice purpose only. Under no circumstances should this be presumed as sample questions.',
      'Mock test is meant for creating awareness about the test delivery system. Contents are for sample only and actual content will be different on the day of examination.',
    ],
  },
  {
    id: 'important',
    title: 'Some important instructions for the exam are as follows:',
    items: [
      'Pen, Pencil, Cell phones, pagers, calculators, Pen Drives, Tablets or any electronic devices are strictly prohibited. Violation will lead to expulsion from the examination.',
      'Improper conduct will entail expulsion from the examination. Failure to comply with the instructions will entail cancellation of candidature including appropriate legal action.',
      'Follow the instruction given before or after any screen during the computer based exam.',
      'Always maintain peace, discipline and silence during the examination process.',
      'NBE reserves all rights to verify identity and genuineness of each candidate at the exam centre by taking thumb impression and photograph of the candidate or by any other means.',
      'Late entry and/or early exit is not permitted.',
      'Please read the information bulletin carefully.',
    ],
  },
];
